import { combineReducers } from "redux";
import Books from "../Models/Books/Reducer";
import { Chapters } from "../Models/Chapters/Reducer";
import { Sections } from "../Models/Sections/Reducer";
import { Exercises } from "../Models/Exercise/Reducer";
import RTag from "../Models/Tag/Reducer";
import { App } from "Models/App/Reducer";
import { RUser } from "Models/Users/Reducer";
import RWeeklyTech from '../Models/WeeklyTech/Reducer';
import Definition from "./definitions";

const RootReducer = combineReducers({
    App,
    Books,
    Chapters,
    Sections,
    Users: RUser,
    Exercises,
    WeeklyTech: RWeeklyTech,
    Definitions: Definition,
    Tag: RTag
});

export type ReduxStore = ReturnType<typeof RootReducer>

export default RootReducer;